module.exports = __webpack_public_path__ + "img/logo.07c0ad58.png";